export class Transfer {
    MYMAINID: number;
    MAINIDOTHER: number;
    LOAN: boolean;
  scum: number;
  coin:number;
}
